// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"9ad69e9745a5a7afc610","691":"f7f8999f4833a5e2981e"}[chunkId] + ".js";
};